import { Link } from 'react-router-dom';
import { newVideos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function NewSection() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 rounded-full bg-accent-500"></div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            最新更新
          </h2>
        </div>
        <Link
          to="/category/variety"
          className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {newVideos.map((video) => (
          <VideoCard key={video.id} video={video} size="sm" />
        ))}
      </div>
    </section>
  );
}